import { render } from "./DialogModel.vue?vue&type=template&id=f688ebd4"
import script from "./DialogModel.vue?vue&type=script&lang=js"
export * from "./DialogModel.vue?vue&type=script&lang=js"

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__